// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"8923da8a","456":"550b0217","656":"d5634ddf","756":"8ac4f9c1","787":"b02237bf","968":"78df1539"}[chunkId] + ".chunk.js";
};